<template>
  <div class="app-sidebar">
    <!-- 我的功能模块 -->
    <div class="sidebar-module-card">
      <h3 class="module-title">我的功能</h3>
      <div class="category-section">
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '我的账户', 'myAccount')">我的账户</span>
        </div>
      </div>
    </div>

    <!-- 北交所模块 -->
    <div class="sidebar-module-card">
      <h3 class="module-title">北交所</h3>
      
      <!-- 业务分类 -->
      <div class="category-section">
        <h4 class="section-title">业务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '并购重组', 'mergersAndAcquisitions')">并购重组</span>
        </div>
      </div>
      <!-- 服务分类 -->
      <div class="category-section">
        <h4 class="section-title">服务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '核心池', 'corePool', {comp_exch:'BJ'}, {})">核心池</span>
          <span class="function-item" @click="$emit('open-tab', 'Top50', 'top50PortfolioDetail', {}, {group_type: 50,index_type:'ZM'})">Top50</span>
          <span class="function-item" @click="$emit('open-tab', '调研报告', 'investigationReport', { comp_exch: 'BJ' })">调研报告</span>
          <span class="function-item" @click="$emit('open-tab', '标签管理', 'sectorDataTable')">标签</span>
        </div>
      </div>
      
      <!-- 数据分类 -->
      <div class="category-section">
        <h4 class="section-title">数据</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '行情统计', 'marketPerformance',{ comp_exch: 'BJ' })">行情统计</span>
          <span class="function-item" @click="$emit('open-tab', '大宗交易', 'blockTrades',{ comp_exch: 'BJ' })">大宗交易</span>
          <span class="function-item" @click="$emit('open-tab', '龙虎榜', 'dragonAndTigerList')">龙虎榜</span>
        </div>
      </div>
      
    </div>

    <!-- IPO模块 -->
    <div class="sidebar-module-card">
      <h3 class="module-title">IPO</h3>
      
      <!-- 数据分类 -->
      <div class="category-section">
        <h4 class="section-title">服务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '潜力公司', 'highPotentialCompany')">潜力公司</span>
          <span class="function-item" @click="$emit('open-tab', '筹备期', 'ipoStateList', { state_stage: '筹备期' })">筹备期</span>
          <span class="function-item" @click="$emit('open-tab', '辅导期', 'ipoStateList', { state_stage: '辅导期' })">辅导期</span>
          <span class="function-item" @click="$emit('open-tab', '审核期', 'ipoStateList', { state_stage: '审核期' })">审核期</span>
          <span class="function-item" @click="$emit('open-tab', '审议期', 'ipoStateList', { state_stage: '审议期' })">审议期</span>
          <span class="function-item" @click="$emit('open-tab', '注册期', 'ipoStateList', { state_stage: '注册期' })">注册期</span>
        </div>
      </div>
      
      <!-- 工具分类 -->
      <div class="category-section">
        <h4 class="section-title">数据</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '上会过会', 'ipoReviewMeeting')">上会过会</span>          
          <span class="function-item" @click="$emit('open-tab', '发行方案', 'ipoIssuePlan')">发行方案</span>
          <span class="function-item" @click="$emit('open-tab', '终止原因', 'ipoTermination')">终止原因</span>
          <span class="function-item" @click="$emit('open-tab', '问询问题', 'ipoInquiry')">问询问题</span>
          <span class="function-item" @click="$emit('open-tab', '参会委员', 'committeeMembers')">参会委员</span>
        </div>
      </div>
    </div>

    <!-- 新三板模块 -->
    <div class="sidebar-module-card">
      <h3 class="module-title">新三板</h3>
      
      <!-- 业务分类 -->
      <div class="category-section">
        <h4 class="section-title">业务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '定向增发', 'privatePlacement')">定向增发</span>
          <span class="function-item" @click="$emit('open-tab', '壳交易', 'shellTransactions')">壳交易</span>
        </div>
      </div>
            
      <!-- 服务分类 -->
      <div class="category-section">
        <h4 class="section-title">服务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '研究报告', 'investigationReport',{ comp_exch: 'NQ' })">研究报告</span>
          <span class="function-item" @click="$emit('open-tab', '机构名录', 'institutionDirectory')">机构名录</span>
          <span class="function-item" @click="$emit('open-tab', '做市商变动', 'marketMakerChange')">做市商变动</span>
          <span class="function-item" @click="$emit('open-tab', '股票池', 'stocksGroup',{ comp_exch: 'NQ' })">股票池</span>
        </div>
      </div>
      
      <!-- 数据分类 -->
      <div class="category-section">
        <h4 class="section-title">数据</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '挂牌公司', 'newlyListed')">挂牌公司</span>
          <span class="function-item" @click="$emit('open-tab', '大宗交易', 'blockTrades',{ comp_exch: 'NQ' })">大宗交易</span>
          <span class="function-item" @click="$emit('open-tab', '行情统计', 'marketPerformance',{ comp_exch: 'NQ' })">行情统计</span>
        </div>
      </div>
    </div>

    <!-- 一级市场模块 -->
    <div class="sidebar-module-card">
      <h3 class="module-title">一级市场</h3>
      
      <!-- 业务分类 -->
      <div class="category-section">
        <h4 class="section-title">业务</h4>
        <div class="function-items">
          <span class="function-item" @click="$emit('open-tab', '项目库', 'projectDirectory')">项目库</span>
          <span class="function-item" @click="$emit('open-tab', '立项库', 'projectFoundList',{})">立项库</span>
          <span class="function-item" @click="$emit('open-tab', '投前', 'preInvestment')">投前</span>
          <span class="function-item" @click="$emit('open-tab', '投中', 'duringInvestment')">投中</span>
          <span class="function-item" @click="$emit('open-tab', '投后', 'postInvestment')">投后</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSidebar"
};
</script>

<style scoped>
.app-sidebar {
  width: 300px;
  background-color: #f5f5f5;
  border-right: 1px solid #eee;
  padding: 16px;
  padding-bottom: 80px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 60px);
  box-sizing: border-box;
}

/* 自定义滚动条样式 - Webkit浏览器 */
.app-sidebar::-webkit-scrollbar {
  width: 6px;
}

.app-sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.app-sidebar::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  transition: background-color 0.3s;
}

.app-sidebar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

/* 模块卡片样式 */
.sidebar-module-card {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaed;
  padding: 12px;
  margin-bottom: 6px;
  transition: all 0.2s;
}

.sidebar-module-card:hover {
  border-color: #d0d7de;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.sidebar-module-card:last-child {
  margin-bottom: 0;
}

/* 模块标题 */
.module-title {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

/* 分类区域 */
.category-section {
  margin-bottom: 10px;
}

.category-section:last-child {
  margin-bottom: 0;
}

/* 分类标题 */
.section-title {
  margin: 0 0 6px 0;
  font-size: 10px;
  font-weight: 500;
  color: #666;
  padding-left: 6px;
  border-left: 2px solid #1890ff;
}

/* 功能项列表 */
.function-items {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* 功能项 */
.function-item {
  display: inline-block;
  padding: 4px 8px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  color: #333;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.function-item:hover {
  background: #e6f7ff;
  border-color: #91d5ff;
  color: #1890ff;
  transform: translateY(-1px);
}

.function-item:active {
  background: #bae7ff;
}
</style>
